module.exports = __webpack_public_path__ + "2b288afe4e6a443f52c58f930b34234e.gif";